// 全局数据不多，因此不使用vuex
var globalData = {
    replyId: 0
}

export default globalData;